import { PersonalDataLayout } from "@features/layout";

export const PersonalDataPage = () => {
  return <PersonalDataLayout />;
};
